import { createFeatureSelector, createSelector } from '@ngrx/store';

import { ServiceProvider } from '@models';
import { ServiceProviderState } from '@state';
import { RouteState, selectRouteState } from '@state/route';

export const selectServiceProviderState =
  createFeatureSelector<ServiceProviderState>('serviceProvider');

export const selectServiceProviders = createSelector(
  selectServiceProviderState,
  (state: ServiceProviderState) => state.serviceProviders ?? []
);

export const selectCurrentServiceProvider = createSelector(
  selectServiceProviders,
  selectRouteState,
  (items: ServiceProvider[], route: RouteState) => {
    return items.find((x) => x.id == route.params['serviceProviderId']);
  }
);

export const selectServiceProvidersFetchedAt = createSelector(
  selectServiceProviderState,
  (state: ServiceProviderState) => state.fetchedAt
);


